import { cn } from "@/shared/lib/utils";

const TypographyMuted = ({
  text,
  icon,
  className,
}: {
  text?: string | React.ReactNode
  icon?: React.ReactNode
  className?: string
}) => {
  return (
    <p className={cn("text-muted-foreground text-base", icon && "flex items-center gap-2", className)}>
      {icon && <span>{icon}</span>}
      {text}
    </p>
  );
};

export default TypographyMuted;
